


























import Vue from 'vue';

import Loader from '@/components/Loader.vue';

export default Vue.extend({
  components: {
    Loader,
  },
  // data() {
  //   return {
  //     loading: !this.$parent.hasLoadedData,
  //   };
  // },
  name: 'FormSection',
  inject: ['$validator'],
  props: {
    btnText: {
      default: 'add',
      required: false,
      type: String,
    },
    header: {
      required: true,
      type: String,
    },
    isEditable: {
      type: Boolean,
    },
    isEditing: {
      default: false,
      type: Boolean,
    },
    sectionId: {
      required: false,
    },
    subheading: {
      default: '',
      required: false,
    },
  },
});
